/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useCallback, useContext, useEffect, useState } from 'react'
// import { Label } from 'core/screen-util'
import {
  // Button,
  DatePicker,
  Input,
  InputNumber,
  Select,
  // message,
  Divider,
  Modal,
  Spin,
  message,
  Button,
} from 'antd'
import styled from '@emotion/styled'
import TextArea from 'antd/lib/input/TextArea'
import moment from 'moment'
import { ErrorContext, SpinContext } from 'context'
import {
  getInstalledCapacitiveClaimedEffective,
  netCapacitiveVerificationUpdate,
} from '../../api/pgads'
import { UtilityUnitSelection } from 'core'
import JcTmpErrorContext from '../../context/JcTmpErrorContext'
import { isErrorContains } from '../../core/component/JcTmpErrorDialog'
import { dataSavedMessage } from '../../core/screen-util'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

export const getClaimedInstalled = (claimedInstalled, unitId, period) => {
  const claimedinstalled = claimedInstalled.find(u => u.unitId === unitId)
  return claimedinstalled
    ? period === 'S'
      ? claimedinstalled.instCapSum
      : claimedinstalled.instCapWin
    : undefined
}

const parseFloatData = val => {
  if (val === undefined || val == null) return undefined
  if (isNaN(val)) return undefined
  const nv = parseFloat(val)
  if (isNaN(nv)) return undefined
  return parseFloat(nv.toFixed(4))
}
const isValuePresent = val => {
  if (val === undefined || val == null || isNaN(val)) return false
  else return true
}

const NetCapVerDataDialog = ({
  onCancel,
  data,
  // insertData,
  // setInsertData,
  //  claimedInstalled,
  targetInfo,
  onRetrieve,
  visible,
}) => {
  // const [insertData, updateInsertData] = useState({})

  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const [insertData, setInsertData] = useState(data)
  let { unitId, unit, utility, period, action } = insertData || data
  unitId = unitId || utility + unit
  const [claimedInstalled, setClaimedInstalled] = useState([])
  useEffect(
    _ => {
      getInstalledCapacitiveClaimedEffective(targetInfo)(
        unitId ? [unitId] : []
      ).fork(setError, setClaimedInstalled)
    },
    [targetInfo, setError, unitId]
  )

  useEffect(
    _ => {
      // if(R.equals(insertData.unitId,unitId))
      // setInsertData({
      //   ...insertData,
      //   claimedinstalled: getClaimedInstalled(claimedInstalled, unitId, period),
      // })
      updateInsertData({
        ...insertData,
        claimedinstalled: getClaimedInstalled(claimedInstalled, unitId, period),
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [claimedInstalled, unitId]
  )

  const updateInsertData = data => {
    const {
      grossmw,
      processloadserved,
      stationservice,
      // correctednet,
      claimedinstalled,
      reactivegenmvar,
      airtempmwCorr,
      relhumiditymwCorr,
      cwatertempmwCorr,
    } = data

    let nettestcapability
    if (
      isValuePresent(grossmw) &&
      isValuePresent(processloadserved) &&
      isValuePresent(stationservice)
    )
      nettestcapability =
        parseFloatData(grossmw) -
        parseFloatData(processloadserved) -
        parseFloatData(stationservice)

    let powerfactor
    if (isValuePresent(reactivegenmvar) && isValuePresent(grossmw)) {
      const grsmw = parseFloatData(grossmw)
      const grs = grsmw * grsmw
      let rmvr = parseFloatData(reactivegenmvar)
      rmvr = rmvr * rmvr

      const sqrt = Math.sqrt(grs + rmvr)
      powerfactor = parseFloatData(grsmw / sqrt)
    }

    let totalpowermva
    if (isValuePresent(grossmw) && isValuePresent(reactivegenmvar)) {
      const grsmw = parseFloatData(grossmw)
      const grs = grsmw * grsmw
      let rmvr = parseFloatData(reactivegenmvar)
      rmvr = rmvr * rmvr
      totalpowermva = parseFloatData(Math.sqrt(grs + rmvr))
    }

    let correctednetNew
    if (
      // isValuePresent(airtempmwCorr)  &&
      // isValuePresent(relhumiditymwCorr) &&
      // isValuePresent(cwatertempmwCorr) &&
      isValuePresent(nettestcapability)
    ) {
      correctednetNew =
        parseFloatData(airtempmwCorr || 0) +
        parseFloatData(relhumiditymwCorr || 0) +
        parseFloatData(cwatertempmwCorr || 0) +
        parseFloatData(nettestcapability)
    }

    let difference
    if (isValuePresent(correctednetNew) && isValuePresent(claimedinstalled))
      difference =
        parseFloatData(correctednetNew) - parseFloatData(claimedinstalled)

    setInsertData({
      ...data,
      nettestcapability: parseFloatData(nettestcapability),
      difference: parseFloatData(difference),
      powerfactor: parseFloatData(powerfactor),
      totalpowermva: parseFloatData(totalpowermva),
      correctednet: parseFloatData(correctednetNew),
    })
  }

  const InputNumberComp = useCallback(
    ({ field, disabled = false, suffix = '', label = '', insertData = {} }) => {
      return (
        <React.Fragment>
          {label.length > 0 && <Label>{label}</Label>}
          <InputNumber
            key={field}
            value={insertData[field]}
            onChange={value =>
              updateInsertData({ ...insertData, [field]: value })
            }
            // onChange={e =>
            //   updateInsertData({ ...insertData, [field]: e.target.value })
            // }
            disabled={disabled}
          />
          <Label css={{ justifyContent: 'left' }}>{suffix}</Label>
        </React.Fragment>
      )
    },
    []
  )

  const testInsertData = _ => {
    // const modifiedValue={...insertData,utility:'297',unit:'505',year:'2022',period:'S',testidx:'1'}
    // onAdd(true)
    // onAdd(true)
    if (action === 'I' && insertData.unitId === undefined) {
      message.warning('Please, Select Unit.')
      return
    }

    setSpinning(true)
    netCapacitiveVerificationUpdate(targetInfo)([insertData]).fork(
      setError,
      tmpError => {
        setSpinning(false)
        if (!isErrorContains(tmpError)) {
          dataSavedMessage()
          onRetrieve()
          onCancel()
        }
        setTmpError(tmpError)
      }
    )
  }

  return (
    <Modal
      destroyOnClose
      title={
        'Net Capacity Verification Data : ' +
        (action === 'I' ? 'Insert' : 'Update')
      }
      visible={visible}
      onCancel={onCancel}
      onOk={testInsertData}
      okButtonProps={{ loading: spinning }}
      cancelButtonProps={{ loading: spinning }}
      centered
      width={1000}
      height="100%"
      bodyStyle={{}}
      okText={action === 'I' ? 'Insert' : 'Update'}
      zIndex={500}
      footer={
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto auto',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ color: 'red' }}>
            {action === 'I' && insertData.unitId === undefined
              ? 'Please, Select Unit'
              : ''}
          </div>{' '}
          <div>
            <Button onClick={onCancel} loading={spinning}>
              Cancel
            </Button>{' '}
            <Button onClick={testInsertData} type="primary" loading={spinning}>
              {action === 'I' ? 'Insert' : 'Update'}
            </Button>
          </div>
        </div>
      }
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              '200px 100px 30px 200px 100px 30px 100px 30px 100px 30px',
            gap: '2px',
          }}
        >
          <div style={{ gridColumnEnd: 'span 4' }}>
            <UtilityUnitSelection
              utility={insertData.utility}
              unit={insertData.unitId}
              onUnitChange={value => {
                // setUtilityUnit(value)
                setInsertData({
                  ...insertData,
                  utility: value[0],
                  unit: value[1].substr(3),
                  unitId: value[1],
                  // claimedinstalled: getClaimedInstalled(
                  //   claimedInstalled,
                  //   value[1],
                  //   period
                  // ),
                })
              }}
              disabled={action !== 'I'}
              // etcProps={{ disabled: action !== 'I' }}
              // etcProps={{ disabled: true }}
              casStyle={{ width: '100%' }}
            />
          </div>

          {/* <Label>Year :</Label> */}
          {/* <InputNumberComp
        label=""
        field="year"
        suffix=""
        disabled={action !== 'I'}
      /> */}
          <InputNumber
            value={insertData.year}
            onChange={year => setInsertData({ ...insertData, year })}
            disabled={action !== 'I'}
            style={{ gridColumnEnd: 'span 2' }}
          />
          {/* <Label>Season :</Label> */}
          <Select
            style={{ gridColumnEnd: 'span 1' }}
            value={insertData.period}
            onChange={val => {
              setInsertData({ ...insertData, period: val })
            }}
            allowClear={false}
            disabled={action !== 'I'}
          >
            <Select.Option value="S" key="S">
              Summer
            </Select.Option>
            <Select.Option value="W" key="W">
              Winter
            </Select.Option>
          </Select>

          {/* <div
        style={{
          gridColumnEnd: 'span 2',
          display: 'grid',
          justifyContent: 'center',
          alignContent: 'end',
        }}
      >
        Test Index :
      </div> */}
          <div />
          <div
            style={{
              gridColumnEnd: 'span 2',
              display: 'grid',
              justifyContent: 'center',
              alignContent: 'end',
            }}
          >
            <Input
              value={
                'Test Index : ' +
                // eslint-disable-next-line eqeqeq
                (insertData.testidx == -99 ? '' : insertData.testidx)
              }
              disabled
              style={{
                width: '100%',
                display: action === 'I' ? 'NONE' : undefined,
              }}
            />
          </div>
          <div style={{ gridColumnEnd: 'span 10' }}>
            <Divider style={{ margin: '2px' }} />
          </div>
          <InputNumberComp
            insertData={insertData}
            label="Corrected Net Test Capacity :"
            field="correctednet"
            suffix="(MW)"
            disabled
          />
          <div style={{ gridColumnEnd: 'span 7' }} />
          <InputNumberComp
            insertData={insertData}
            label="Claimed Installed Capacity :"
            field="claimedinstalled"
            suffix="(MW)"
            disabled
          />

          <Label>Test Start Date-Time :</Label>
          <DatePicker
            style={{ gridColumnEnd: 'span 6' }}
            showTime
            format="MM/DD/YYYY HH:mm"
            value={
              insertData.teststartdate2 ||
              (insertData.teststartdate && moment(insertData.teststartdate))
            }
            onChange={date =>
              updateInsertData({
                ...insertData,
                teststartdate2: date,
                teststartdate: date.format('YYYY-MM-DDTHH:mm:ss'),
              })
            }
          />

          <InputNumberComp
            insertData={insertData}
            label="Difference (+ or -) :"
            field="difference"
            suffix="(MW)"
            disabled
          />
          <Label>Test End Date-Time :</Label>
          <DatePicker
            style={{ gridColumnEnd: 'span 6' }}
            showTime
            format="MM/DD/YYYY HH:mm"
            value={
              insertData.testenddate2 ||
              (insertData.testenddate && moment(insertData.testenddate))
            }
            onChange={date =>
              updateInsertData({
                ...insertData,
                testenddate2: date,
                testenddate: date.format('YYYY-MM-DDTHH:mm:ss'),
              })
            }
          />
          <InputNumberComp
            insertData={insertData}
            label="Gross :"
            field="grossmw"
            updateInsertData={updateInsertData}
            suffix="(MW)"
          />
          <div />
          <div style={{ display: 'grid', alignContent: 'end' }}>Observed</div>
          <div />
          <div style={{ display: 'grid', alignContent: 'end' }}>Rated</div>
          <div />
          <div
            style={{
              gridColumnEnd: 'span 2',
              display: 'grid',
              alignContent: 'end',
            }}
          >
            Correction (+ or -){' '}
          </div>
          <InputNumberComp
            insertData={insertData}
            label="Station Service :"
            field="stationservice"
            suffix="(MW)"
          />
          <InputNumberComp
            insertData={insertData}
            label="Dry Bulb Air Temperature :"
            field="dryairtempObserved"
            suffix="(F)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="dryairtempRated"
            suffix="(F)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="airtempmwCorr"
            suffix="(MW)"
          />
          <InputNumberComp
            insertData={insertData}
            label="Process Load Served :"
            field="processloadserved"
            suffix="(MW)"
          />
          <InputNumberComp
            insertData={insertData}
            label="Relative Humidity :"
            field="relhumidityObserved"
            suffix="(%)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="relhumidityRated"
            suffix="(%)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="relhumiditymwCorr"
            suffix="(MW)"
          />
          <InputNumberComp
            insertData={insertData}
            label="Net Test Capacity :"
            field="nettestcapability"
            suffix="(MW)"
            disabled
          />
          <InputNumberComp
            insertData={insertData}
            label="Cooling Water Temperature :"
            field="cwatertempObserved"
            suffix="(F)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="cwatertempRated"
            suffix="(F)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="cwatertempmwCorr"
            suffix="(MW)"
          />
          <InputNumberComp
            insertData={insertData}
            label="Reactive Gen MVAR (+ or -) :"
            field="reactivegenmvar"
            suffix="(MVAR)"
          />
          <InputNumberComp
            insertData={insertData}
            label="Intake Water Temperature :"
            field="iwatertempObserved"
            suffix="(F)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="iwatertempRated"
            suffix="(F)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="iwatertempmwCorr"
            suffix="(MW)"
          />
          <InputNumberComp
            insertData={insertData}
            label="Total Power MVA :"
            field="totalpowermva"
            suffix="(MVA)"
            disabled
          />
          <InputNumberComp
            insertData={insertData}
            label="Wet Bulb Temperature :"
            field="wetairtempObserved"
            suffix="(F)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="wetairtempRated"
            suffix="(F)"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="wetairtempmwCorr"
            suffix="(MW)"
          />
          <InputNumberComp
            insertData={insertData}
            label="Power Factor :"
            field="powerfactor"
            suffix=""
            disabled
          />
          <InputNumberComp
            insertData={insertData}
            label="Barometric Pressure :"
            field="barometricObserved"
            suffix="inHg"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="barometricRated"
            suffix="inHg"
          />
          <InputNumberComp
            insertData={insertData}
            label=""
            field="barometricmwCorr"
            suffix="(MW)"
          />
          <div style={{ gridColumnEnd: 'span 3' }}>
            <Label>From where are the Observed Conditions obtained?</Label>
          </div>

          <Select
            style={{ width: '100%', gridColumnEnd: 'span 1' }}
            value={insertData.observedSiteCode}
            onChange={value =>
              updateInsertData({
                ...insertData,
                observedSiteCode: value,
                observedSiteSpecified:
                  value === '1' ? '' : insertData.observedSiteSpecified,
              })
            }
          >
            <Select.Option key="" value="" />
            <Select.Option key="0" value="0">
              No Weather Data Needed
            </Select.Option>
            <Select.Option key="1" value="1">
              Plant weather station
            </Select.Option>
            <Select.Option key="2" value="2">
              Local/City/Airport weather station
            </Select.Option>
            <Select.Option key="3" value="3">
              Other
            </Select.Option>
          </Select>
          <Label>Specify :</Label>
          <Input
            style={{ gridColumnEnd: 'span 5' }}
            value={insertData.observedSiteSpecified}
            onChange={e =>
              updateInsertData({
                ...insertData,
                observedSiteSpecified: e.target.value,
              })
            }
            // eslint-disable-next-line eqeqeq
            disabled={insertData.observedSiteCode == 1}
          />

          <div style={{ gridColumnEnd: 'span 3' }}>
            <Label>From where are the Rated Conditions obtained?</Label>
          </div>

          <Select
            style={{ width: '100%', gridColumnEnd: 'span 1' }}
            value={insertData.ratedSiteCode}
            onChange={value =>
              updateInsertData({
                ...insertData,
                ratedSiteCode: value,
                ratedSiteSpecified:
                  value === '1' ? '' : insertData.ratedSiteSpecified,
              })
            }
          >
            <Select.Option key="" value="" />
            <Select.Option key="0" value="0">
              No Weather Data Needed
            </Select.Option>
            <Select.Option key="1" value="1">
              Plant weather station
            </Select.Option>
            <Select.Option key="2" value="2">
              Local/City/Airport weather station
            </Select.Option>
            <Select.Option key="3" value="3">
              Other
            </Select.Option>
          </Select>
          <Label>Specify :</Label>
          <Input
            style={{ gridColumnEnd: 'span 5' }}
            value={insertData.ratedSiteSpecified}
            onChange={e =>
              updateInsertData({
                ...insertData,
                ratedSiteSpecified: e.target.value,
              })
            }
            // eslint-disable-next-line eqeqeq
            disabled={insertData.ratedSiteCode == '1'}
          />
          <div
            style={{
              gridColumnEnd: 'span 10',
              display: 'grid',
              gridTemplateColumns: '100px auto',
            }}
          >
            <div
              style={{
                display: 'grid',
                columnGap: '2px',
                justifyContent: 'end',
                alignContent: 'center',
              }}
            >
              Note :
            </div>
            <TextArea
              style={{ width: '100%' }}
              rows={2}
              value={insertData.note}
              onChange={e =>
                updateInsertData({ ...insertData, note: e.target.value })
              }
            />
          </div>
          {/* <Button onClick={testInsertData}>Add</Button>
        <Button onClick={onCancel}>Cancel</Button> */}
        </div>
      </Spin>
    </Modal>
  )
}

export default NetCapVerDataDialog
